/* eslint-disable jira/wrm/no-load-bridge */

import {
	wrmRequire,
	wrmRequireWithPrefetch,
	type BatchDetailsResponseType,
} from '@atlassian/jira-common-bridge/src';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const asyncWrmRequire = (resourcesToRequire: string[]): Promise<any> =>
	wrmRequire(resourcesToRequire);

export const asyncWrmRequireWithPrefetch = (
	resourcesToRequire: string[],
	batchUrl: BatchDetailsResponseType, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => wrmRequireWithPrefetch(resourcesToRequire, batchUrl);
